import api from "../services/api";

import { IGerenteRegional, ISearchRequest, ISearchResponse } from "../interfaces";

export interface IRegionalManagerListModel {
    id?: string;
    status: number;
    devedor: number;
    cpf: string;
    nome: string;
    cidade: string;
}

class RegionalManagerRepository {

    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<IRegionalManagerListModel>> => {

        const response = await api.get<ISearchResponse<IRegionalManagerListModel>>("gerenteregional", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public GetById = async (id: string): Promise<IGerenteRegional> => {
        const response = await api.get<IGerenteRegional>(`gerenteregional/${id}`);

        return response.data;
    }
}

const regionalManagerRepository = new RegionalManagerRepository();
export default regionalManagerRepository;
